import { BASE_URL, FREE_BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("cc_pssm_api");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    config.headers.Authorization = null;
  }

  return config;
}, function (error) {
  console.log('AN ERROR REQUEST', error)
});

const currentAnnee = localStorage.getItem("currentAnnee")
  ? JSON.parse(localStorage.getItem("currentAnnee"))
  : null;

export const listeDesPermissionPaginee = async (page = 1, size = 10, param = "") => {  
  return await axios.get(
    BASE_URL(`permission/query?page=${page}&size=${size}&param=${param}`),
    {}
  );
};

export const listeCompleteDesPermission = async () => {
  return await axios.get(
    BASE_URL(`permission`),
    {}
  );
};


export const recuperePermissionParSonId = async (niveauId) => {
  return await axios.get(
    BASE_URL(`permission/${niveauId}`),
    {}
  );
};

export const ajouterUnePermission = async (values) => {
  return await axios.post(
    BASE_URL(`permission`),
    values
  );
};

export const modifierUnePermission = async (values, niveauId) => {
  return await axios.put(
    BASE_URL(`permission/${niveauId}`),
    values
  );
};

export const supprimerUnePermission = async (niveauId) => {
  return await axios.delete(
    BASE_URL(`permission/${niveauId}`),
    {}
  );
};
